module.exports = __webpack_public_path__ + "static/media/Inter-Regular.079af0e2.ttf";